module.exports = __webpack_public_path__ + "img/imagen4.278b105b.png";